/**
 * Source of truth for route prefixes that must never reach any third-party
 * analytics/telemetry. This module is intentionally dependency-free so it
 * can be imported from Edge middleware as well as client and server code.
 */
export const SENSITIVE_ROUTES = [
  "/send/confidential",
  "/transfer",
  "/gift",
  "/deal",
  "/api/gifts",
  "/api/otc_trades",
] as const

export function isOnSensitiveRoute(
  pathname: string | null | undefined
): boolean {
  if (pathname == null) return false
  return SENSITIVE_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  )
}
